import React from 'react';
import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import isEmpty from '../../utils/isEmpty';
import styles from './NewsListPage.module.scss';
import NewsListModule from '../../components/NewsListModule';
import Pagination from '../../components/Pagination';
import Notice from '../../components/Notice';
import Breadcrumbs from '../../components/Breadcrumbs';
import Select from '../../components/Select';
import i18n from '../../i18n';

const NewsListPage = ({
    breadcrumbs,
    title,
    preamble,
    news,
    notices,
    filters,
    isAreaOrProject,
}) => {
    const preHeadlineText = isAreaOrProject
        ? i18n.t('newsListPage.areaProjectHeadline')
        : '';

    return (
        <div className={styles['NewsListPage']}>
            <div className={styles['NewsListPage__Container']}>
                <h1 className={styles['NewsListPage__Title']}>
                    {preHeadlineText}
                    {title}
                </h1>
                <div className={styles['NewsListPage__Preamble']}>
                    {preamble}
                </div>
            </div>

            {!isEmpty(filters) && (
                <form
                    className={styles['NewsListPage__Filters']}
                    id="filter_form">
                    <Select
                        options={filters.years.map((i) => ({
                            label: i,
                            value: i,
                        }))}
                        hideLabel={true}
                        id="id_year"
                        name="year"
                        labelAll={'Alla år'}
                        defaultValue={filters.defaultYear}
                        label={'Filtrera på år'}
                    />
                    <button
                        type="submit"
                        className={styles['NewsListPage__Filter']}>
                        Filtrera
                    </button>
                </form>
            )}

            {!isEmpty(notices) && (
                <div className={styles['NewsListPage__NoticeWrapper']}>
                    {notices.map((notice) => (
                        <Notice
                            key={notice.href}
                            {...notice}
                            modifier={'NewsPage'}
                        />
                    ))}
                </div>
            )}

            <NewsListModule {...news} />
            {news.pagination && <Pagination {...news.pagination} />}
        </div>
    );
};

NewsListPage.propTypes = {
    title: PropTypes.string,
    preamble: PropTypes.string,
    news: PropTypes.object,
    filters: PropTypes.object,
};

NewsListPage.defaultProps = {
    title: '',
    preamble: '',
    news: {},
    filters: {},
};

export default basePageWrap(NewsListPage);
